<template>
  <v-row>
    <v-col
      cols="12"
      md="6"
      lg="4"
    >
      <ValidationProvider
        ref="siteIdValidation"
        v-slot="{ errors }"
        rules="required"
        name="Site Id"
      >
        <v-text-field
          v-model="siteIdLocal"
          label="Site Id"
          :error-messages="errors"
        />
      </ValidationProvider>
    </v-col>
    <v-col
      cols="12"
      md="6"
      lg="4"
    >
      <ValidationProvider
        v-slot="{ errors }"
        rules="required"
        name="Api Key"
      >
        <v-text-field
          v-model="apiKeyLocal"
          label="Api Key"
          :error-messages="errors"
        />
      </ValidationProvider>
    </v-col>
    <v-col
      cols="12"
      md="6"
      lg="4"
    >
      <timezone :timezone.sync="timezoneLocal" />
      <div class="caption">
        Appointment Plus returns appointment dates without timezone information. The timezone that
        is selected here will be used for all appointments.
      </div>
    </v-col>
  </v-row>
</template>

<script>
import Timezone from '../Timezone';

export default {
  name: 'AppointmentPlus',
  components: {
    Timezone,
  },
  props: {
    siteId: {
      type: String,
      required: false,
      default: '',
    },
    apiKey: {
      type: String,
      required: false,
      default: '',
    },
    timezone: {
      type: String,
      required: false,
      default: '',
    },
    errorMessage: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      siteIdLocal: this.siteId,
      apiKeyLocal: this.apiKey,
      timezoneLocal: this.timezone,
    };
  },
  watch: {
    errorMessage() {
      if (this.errorMessage === 'InvalidSiteIdApiKey') {
        this.$refs.siteIdValidation.setErrors(['Invalid Site Id or Api Key']);
      }
    },
  },
  methods: {
    getDetail() {
      return {
        siteId: this.siteIdLocal,
        apiKey: this.apiKeyLocal,
        timezone: this.timezoneLocal,
      };
    },
  },
};
</script>
